// extracted by mini-css-extract-plugin
module.exports = {"story-list":"_1S3Mp"};